import { Component } from '@theme/component';

/**
 * A custom element that scrolls to the next section when clicked.
 *
 * @extends Component
 */
export class ScrollIndicatorComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = () => {
    const currentSection = this.closest('.shopify-section, [data-section-id]');
    const nextSection = currentSection?.nextElementSibling;

    nextSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
}

customElements.define('scroll-indicator-component', ScrollIndicatorComponent);
